import { getItem, setItem } from './syncedLocalStorage';

export const getSessionId = () => getItem('rpSessionId');
export const setSessionId = sessionId => setItem('rpSessionId', sessionId);
